import Grid from "@mui/material/Grid";
import Section from "../components/ui/Section";
import TestimonialCard from "../components/ui/TestimonialCard";
import { TESTIMONIALS } from "../content/testimonials";
import { headers } from "../content/meta";

export default function Clients() {
  return (
    <Section id="clients" header={headers.clients}>
      <Grid container spacing={2}>
        {TESTIMONIALS.map((t, i) => (
          <Grid key={i} size={{ xs: 12, sm: 6, lg: 4 }}>
            <TestimonialCard {...t} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}
